import { state } from "@src/apps/Hsd/Main/constant";
import { 
    PCOR_DATA_REQUEST, 
    PCOR_DATA_FAILURE, 
    PCOR_DATA_SUCCESS, 
    PCOR_DATA_LOADING,
    PCOR_FILTER_REQUEST,
    PCOR_FILTER_FAILURE,
    PCOR_FILTER_SUCCESS,
    PCOR_FILTER_LOADING
} from "@src/middleware/actions/actionTypes";
import def from "ajv/dist/vocabularies/discriminator";


interface PCORState {
    patientCareMetricsData: any;
    patientCareMetricsIsLoading: boolean;
    patientCareMetricsError: boolean;
    pcorFilterData: any;
    pcorFilterIsLoading: boolean;
    pcorFilterError: boolean;
}

const initialState: PCORState = {
    patientCareMetricsData: {},
    patientCareMetricsIsLoading: false,
    patientCareMetricsError: false,
    pcorFilterData: {},
    pcorFilterIsLoading: false,
    pcorFilterError: false,
};

const PCORReducer = (
    state = initialState,
    action: { type: string; payload?: any }

): PCORState => {
    switch (action.type) {
        case PCOR_DATA_LOADING:
            return {
                ...state,
                patientCareMetricsIsLoading: action.payload,
            };

        case PCOR_DATA_SUCCESS:
            return {
                ...state,
                patientCareMetricsData: action.payload,
            };

        case PCOR_DATA_FAILURE:
            return {
                ...state,
                patientCareMetricsError: action.payload,
            };
        
        case PCOR_FILTER_LOADING:
            return {
                ...state,
                pcorFilterIsLoading: action.payload,
            };

        case PCOR_FILTER_SUCCESS:
            return {
                ...state,
                pcorFilterData: action.payload,
            };

        case PCOR_FILTER_FAILURE:
            return {
                ...state,
                pcorFilterError: action.payload,
            };
        
        default:
            return state;
    }
};

export default PCORReducer;